import React from 'react';

function RUIcon({ w, h, style, className }) {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 18 18"
      style={style}
    >
      <defs>
        <filter
          id="a"
          width="118.8%"
          height="118.8%"
          x="-9.4%"
          y="-9.4%"
          filterUnits="objectBoundingBox"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation=".5" />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.296705163 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g fill="none" fillRule="nonzero" filter="url(#a)" transform="translate(1 1)">
        <circle cx="8" cy="8" r="8" fill="#FCFCFC" />
        <path
          fill="#6DA544"
          d="M12.522 6.957h-1.044a3.478 3.478 0 0 1-6.956 0H3.478c0 2.069 1.39 3.813 3.287 4.35-.208.396-.176.893.121 1.264l1.137-.911 1.137.911c.3-.374.33-.878.115-1.275a4.524 4.524 0 0 0 3.247-4.34z"
        />
        <path
          fill="#FFDA44"
          d="M5.217 6.609s0 1.739 1.74 1.739l.347.348H8s.348-1.044 1.043-1.044c0 0 0-.696.696-.696h1.044s-.348-1.39 1.39-2.434l-.695-.348S9.043 5.913 7.304 5.565v.696H6.61l-.348-.348-1.044.696z"
        />
      </g>
    </svg>
  );
}

RUIcon.defaultProps = {
  w: 18,
  h: 18,
  style: {},
  fill: '#000000',
};

export default RUIcon;
